import React from 'react'
import { Modal, Button } from 'antd';
import styled from 'styled-components'

import icoIncognito from '../../../img/Iconos/incongnito.svg';

const ConfirmationWithOptions = ({ btnSize, onCancel, onOk, text, textSize, show, customizedComponent, loadingBtn }) => {
  return (
    <Modal
      title={false}
      visible={show}
      onCancel={onCancel}
      footer={null}
      bodyStyle={{
        height: 320,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "row"
      }}
      destroyOnClose={true}
      width={600}
    >
      <Wrapper textSize={textSize || '18px'} btnSize={btnSize || '70px'}>
        <img src={icoIncognito} alt="incognito" />
        <div className="text">
          {text}
        </div>
        {
          customizedComponent
        }
        <div className="bottons">
          <Button
            className='botton'
            onClick={() => onCancel()}
            loading={loadingBtn}
          >
            NO
              </Button>
          <Button
            className='botton'
            onClick={() => {
              onOk();
            }}
            loading={loadingBtn}
          >
            SI
              </Button>
        </div>
      </Wrapper>
    </Modal>
  )
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 100px;
  img {
    height: 40px;
    width: 40px;
    margin-bottom: 30px;
  }
  .text {
    font-size: ${({ textSize }) => textSize};
    text-align: center;
    color: #616160 !important;
  }

  /*  botones  */
    .bottons {
            height: 40px;
            margin-top: 20px;
            width: 100%;
            display: flex;
            justify-content: center;
        }
    .botton {
        min-width:  ${({ btnSize }) => btnSize};
        height: 30px;
        color: #E89548;
        font-size: 10px;
        border: 1px #E89548 solid;
        border-radius: 20px;
        font-weight: 600;
        margin: 5px 20px;
        text-transform: uppercase;
        padding: 4px 15px;
        background-color: #fff;
        &:hover {
            border: 1px #E89548 solid;
            background-color: #E89548;
            color: #fff;
            cursor: pointer;
        }
        &:focus {
            background-color: #fff;
            color: #E89548;
            border: 1px #E89548 solid;
        }
    }
`

export default ConfirmationWithOptions



// WEBPACK FOOTER //
// ./src/Components/Utils/Modals/ConfirmationWithOptions.js